import script from "./CommaNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CommaNumberInput.vue?vue&type=script&setup=true&lang=js"

import "./CommaNumberInput.vue?vue&type=style&index=0&id=7b6af8e7&lang=css"

const __exports__ = script;

export default __exports__